import { useIntl } from 'react-intl';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { NavbarItem, NavbarTitles, getNavbarTitles } from './NavbarItems';
import { useEffect, useState } from 'react';
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';

export type DrawerNavbarProps = {
    close: () => void;
}

export default function DrawerNavbar(props: DrawerNavbarProps) {
    const intl = useIntl();
    const navigate = useNavigate();
    const location = useLocation();
    const [navbarTitle, setNavbarTitle] = useState<NavbarTitles[]>([]);
    const { currentUser } = useAuth();

    const amISelected = (path: string): boolean => {
        const samePath: boolean = (location.pathname.toLowerCase() === path.toLowerCase());
        return samePath;
    }

    const { availableModules } = useAvailableModulesContext();

    useEffect(() => {
        const fetchNavbarTitle = async () => {
            try {
                const navbarTitles = await getNavbarTitles();
                const titlesToRemove: any[] = [];

                if (!availableModules.includes("IsActiveScheduler")) {
                    titlesToRemove.push("Navbar.Tab.Scheduler");
                }
                if (!availableModules.includes("IsActiveSupplierQuotation")) {
                    titlesToRemove.push("Navbar.Tab.SupplierQuotation");
                }
                if (!availableModules.includes("IsActiveClientQuotation")) {
                    titlesToRemove.push("Navbar.Tab.ClientQuotation");
                }
                if (!availableModules.includes("IsActiveAuxiliaryEquipments")) {
                    titlesToRemove.push("Navbar.Tab.AuxiliaryEquipments");
                }
                if (!availableModules.includes("ProjectSage50cIsActiveProjectModule")) {
                    titlesToRemove.push("Navbar.Tab.Projects");
                }
                if (!availableModules.includes("IsActiveMaintenanceModule")) {
                    titlesToRemove.push("Navbar.Tab.MaintenancePlans");
                }
                if (!availableModules.includes("IsActiveMaintenanceModule")) {
                    titlesToRemove.push("Navbar.Tab.Reminder");
                }
                if (!availableModules.includes("IsActiveOutscourcingModule")) {
                    titlesToRemove.push("Navbar.Tab.Subcontractors");
                }
                if (!availableModules.includes("IsActiveKpiModule")) {
                    titlesToRemove.push("Navbar.Tab.Kpi");
                }
                if (!availableModules.includes("IsActiveStockManagement")) {
                    titlesToRemove.push("Navbar.Tab.DeliveryNotes");
                }

                // setting de apenas ficar com menus manutenções
                if (availableModules.includes("ShowOnlyMaintenanceMenus")) {
                    titlesToRemove.push("Navbar.Tab.Home");
                    titlesToRemove.push("Navbar.Tab.Equipments");
                    titlesToRemove.push("Navbar.Tab.Clients");
                    titlesToRemove.push("Navbar.Tab.Parts");
                    titlesToRemove.push("Navbar.Tab.Scheduler");
                }

                // Filtrar os títulos e sub-itens
                const filteredNavbarTitles = navbarTitles.map(navbarTitle => {
                    const filteredItems = navbarTitle.navbarItems.filter(navbarItem => {
                        return !titlesToRemove.includes(navbarItem.label);
                    });

                    return {
                        ...navbarTitle,
                        navbarItems: filteredItems
                    };
                }).filter(navbarTitle => navbarTitle.navbarItems.length > 0);

                setNavbarTitle(filteredNavbarTitles);
            } catch (error) {
                console.error('Erro fetching NavBar:', error);
            }
        };

        fetchNavbarTitle();
    }, [availableModules]);

    return (
        <div className='drawer' onClick={props.close}>
            <div className='drawerContent' onClick={(e) => { e.stopPropagation(); }}>
                <div className='drawerOptions'>
                    <div className="drawerClose" onClick={props.close}>x</div>
                </div>
                <div>
                    {navbarTitle.map((r: NavbarTitles) => (
                        r.navbarItems.map((t: NavbarItem) => {
                            return (
                                t.IsVisible(currentUser) === true && (
                                    <div key={t.path} className='drawerItem'>
                                        <NavLink to={t.path} className={amISelected(t.path) ? 'selected' : ''}>
                                            {intl.formatMessage({ id: t.label })}
                                        </NavLink>
                                    </div>
                                )
                            );
                        })
                    ))}
                </div>
            </div>
        </div>
    )
}
